import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import colors from '../../../../styling/colors';
import typography from '../../../../styling/mixins/typography';
import { buildCardsUrl } from '../../../../utils/urls/urlGenerator';
import HandOffLink from '../../../../utils/urls/HandOffLink';

const Container = styled.div`
  ${typography.BasisFont};
  display: flex;
  flex-direction: column;
  margin: 1.5rem 1rem;
`;

const Header = styled.div`
  color: ${colors('silver')};
  margin: 0.25rem 0;
  font-weight: bold;
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const ListItem = styled.li`
  cursor: pointer;
  margin: 1.5rem 0;
`;

export default class Categories extends Component {
  static propTypes = {
    featuredCategories: PropTypes.array,
  };

  static defaultProps = {
    featuredCategories: [],
  };

  render() {
    const { featuredCategories } = this.props;
    const listItems = featuredCategories.map((navNode, i) => {
      return (
        <ListItem key={i}>
          <HandOffLink
            identifier="search_all_categories"
            href={buildCardsUrl(navNode.type + '/' + navNode.slug)}
          >
            {navNode.title}
          </HandOffLink>
        </ListItem>
      );
    });

    return (
      <Container>
        <Header>Top categories</Header>
        <List>{listItems}</List>
      </Container>
    );
  }
}
